import { useContext, useEffect } from 'react';
import { UNSAFE_NavigationContext as NavigationContextUnsafe } from 'react-router-dom';

/**
 * Lightweight navigation blocker for legacy BrowserRouter (non data router).
 * Calls the provided callback whenever navigation is attempted while `when` is true.
 */
export default function useNavigationBlocker(when, onBlock) {
  const navigator = useContext(NavigationContextUnsafe)?.navigator;

  useEffect(() => {
    if (!when || !navigator?.block) {
      return undefined;
    }

    const unblock = navigator.block((tx) => {
      const retry = () => {
        unblock();
        tx.retry();
      };

      onBlock({
        action: tx.action,
        location: tx.location,
        proceed: retry,
      });
    });

    return unblock;
  }, [navigator, when, onBlock]);
}


